import * as React from 'react'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AdminLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  promotion: IJsonResponse
}

const FIELDS = {
  id: 'id',
  code: 'code',
  comment: 'comment',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('promotion', { scope: 'activerecord.models' }),
})

const AdminPromotionEdit: React.FC<IProps> = props => {
  const { data: promotion } = adminService.getDataFromJson(props.promotion)
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { updatedPromotion, flush } = await adminService.updatePromotion(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/admin/promotions'
  }, [])

  return (
    <AdminLayoutEdit
      model="promotion"
      title={title}
      fields={FIELDS}
      indexLink="/admin/promotions"
      formItems={
        <>
          <InputText readonly={true} name="id" defaultValue={promotion.id} label="ID" />
          <InputText required={true} name="code" defaultValue={promotion.code} label="Code" />
          <InputText
            required={false}
            name="comment"
            defaultValue={promotion.comment}
            label="Comment"
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminPromotionEdit
